import { render, staticRenderFns } from "./VulnerabilitiyScores.vue?vue&type=template&id=1eb2db9b&scoped=true&"
import script from "./VulnerabilitiyScores.vue?vue&type=script&lang=js&"
export * from "./VulnerabilitiyScores.vue?vue&type=script&lang=js&"
import style0 from "./VulnerabilitiyScores.vue?vue&type=style&index=0&id=1eb2db9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb2db9b",
  null
  
)

export default component.exports